import axios from "./axios";


export async function uploadMedicalRecord(
  authContext,
  availedServiceId,
  name,
  recordDate,
  recordType,
  file,
  description
  
) {
  const UPLOAD_RECORD_URL = "/api/medicalrecord/UploadMedicalRecord";
  var result = { isSuccess: false, data: {}, errorMessage: "" };
  
  // Create form data for multipart request
  const formData = new FormData();
  //formData.append("FacilityId", authContext?.selectedFacility?.id);
  formData.append("AvailedServiceId", availedServiceId);
  formData.append("Name", name);
  formData.append("RecordType", recordType);
  formData.append("RecordDate", recordDate);

  
  
  if (description) {
    formData.append("Description", description);
  }
  
  formData.append("File", file);
  
  await axios
    .post(UPLOAD_RECORD_URL, formData, {
      headers: {
        Authorization: "Bearer " + authContext.authToken,
        Accept: "application/json, text/plain, */*",
        "Content-Type": "multipart/form-data",
      },
    })
    .then(async function (response) {
      result.isSuccess = true;
      result.data = response?.data;
    })
    .catch(function (error) {
      result.isSuccess = false;
      result.data = error?.response?.data;
      result.errorMessage = error?.response?.data?.message || "Failed to upload medical record";
    });
    
  return result;
}
export async function getMedicalRecordMetadata(
  authContext,
  serviceId
) {
  const GET_METADATA_URL = `/api/medicalrecord/getdocsmetadata/${serviceId}`;
  var result = { isSuccess: false, data: {}, errorMessage: "" };
  
  await axios
    .get(GET_METADATA_URL, {
      headers: {
        Authorization: "Bearer " + authContext.authToken,
        Accept: "*/*",
      },
    })
    .then(async function (response) {
      result.isSuccess = true;
      result.data = response?.data;
    })
    .catch(function (error) {
      result.isSuccess = false;
      result.data = error?.response?.data;
      result.errorMessage = error?.response?.data?.message || "Failed to get medical record metadata";
    });
  
  return result;
}

export async function downloadMedicalRecord(
  authContext,
  id
) {
  const DOWNLOAD_RECORD_URL = `/api/medicalrecord/downloadmedicalrecord/${id}`;
  var result = { isSuccess: false, data: {}, errorMessage: "", fileName: "" };
  
  await axios
    .get(DOWNLOAD_RECORD_URL, {
      headers: {
        Authorization: "Bearer " + authContext.authToken,
        Accept: "*/*",
      },
      responseType: 'blob',
    })
    .then(async function (response) {
      result.isSuccess = true;
      result.data = response?.data;
      
      // Extract filename from content-disposition header if available
      const contentDisposition = response.headers['content-disposition'];
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename=([^;]+)/);
        if (filenameMatch && filenameMatch[1]) {
          result.fileName = filenameMatch[1].replace(/["']/g, '');
        }
      }
      result.contentType = response.headers.get("Content-Type");
    })
    .catch(function (error) {
      result.isSuccess = false;
      result.data = error?.response?.data;
      result.errorMessage = error?.response?.data?.message || "Failed to download medical record";
    });
  
  return result;
}
